import { useHasPermission } from "@dexteel/mesf-core";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Button, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { Link, To } from "react-router-dom";

interface MenuItemConfig {
  label: string;
  to: To;
  permission?: string;
}

interface MenuConfig {
  id: string;
  label: string;
  items: MenuItemConfig[];
  permission?: string;
}

const menuConfigData: MenuConfig[] = [
  {
    id: "meltshop",
    label: "MeltShop",
    permission: "ui.navbar.meltshop",
    items: [
      {
        label: "Heats",
        to: "/meltshop-heats",
        permission: "ui.navbar.meltshop.heats",
      },
      {
        label: "Ladle Maintenance DE",
        to: "/ladle-maintenance",
        permission: "ui.navbar.meltshop",
      },
      {
        label: "Heat Report",
        to: "/heat-process-report",
        permission: "ui.navbar.meltshop",
      },
      {
        label: "Shift Report",
        to: "/shift-report",
        permission: "ui.navbar.meltshop",
      },
    ],
  },
  {
    id: "eaf",
    label: "EAF",
    permission: "ui.navbar.eaf",
    items: [
      {
        label: "Data Entry",
        to: "/eaf-data-entry",
        permission: "ui.navbar.eaf.data-entry",
      },
      {
        label: "Processes By Shift",
        to: "/eaf-processes",
        permission: "ui.navbar.eaf.processes",
      },
      {
        label: "Production Report",
        to: { pathname: "/production-report", search: "?assetId=11" },
        permission: "ui.navbar.eaf.processes",
      },
      {
        label: "Delays Manager",
        to: { pathname: "/delays-manager", search: "?assetId=11" },
        permission: "ui.navbar.eaf.delays-manager",
      },
      {
        label: "Delays Report",
        to: { pathname: "/delays-report", search: "?assetId=11" },
        permission: "ui.navbar.eaf.delays-report",
      },
      {
        label: "Pareto Report",
        to: { pathname: "/delays-pareto", search: "?assetId=11" },
        permission: "ui.navbar.eaf.delays-pareto",
      },
      {
        label: "Roof & Delta Panel",
        to: "/eaf-roof-panel",
        permission: "ui.navbar.eaf.roof-panel",
      },
      {
        label: "Sidewall & Burner",
        to: "/eaf-sidewall",
        permission: "ui.navbar.eaf.sidewall",
      },
    ],
  },
  {
    id: "lmf",
    label: "LMF",
    permission: "ui.navbar.lmf",
    items: [
      {
        label: "Data Entry",
        to: "/lmf-data-entry",
        permission: "ui.navbar.lmf.data-entry",
      },
      {
        label: "Processes By Shift",
        to: "/lmf-processes",
        permission: "ui.navbar.lmf.processes",
      },
      {
        label: "Production Report",
        to: { pathname: "/production-report", search: "?assetId=12" },
        permission: "ui.navbar.lmf.processes",
      },
    ],
  },
  {
    id: "caster",
    label: "Caster",
    permission: "ui.navbar.caster",
    items: [
      {
        label: "Caster Data Entry",
        to: "/caster-data-entry",
        permission: "ui.navbar.caster.data-entry",
      },
      {
        label: "Torches Data Entry",
        to: "/caster-torches",
        permission: "ui.navbar.caster.torches",
      },
      {
        label: "Processes By Shift",
        to: "/caster-processes",
        permission: "ui.navbar.caster.processes",
      },
      {
        label: "Production Report",
        to: { pathname: "/production-report", search: "?assetId=13" },
        permission: "ui.navbar.caster.processes",
      },
      {
        label: "Delays Manager",
        to: { pathname: "/delays-manager", search: "?assetId=13" },
        permission: "ui.navbar.caster.delays-manager",
      },
      {
        label: "Strand Losses Manager",
        to: "/strand-losses-manager",
        permission: "ui.navbar.caster.delays-manager",
      },
      {
        label: "Delays Report",
        to: { pathname: "/delays-report", search: "?assetId=13" },
        permission: "ui.navbar.caster.delays-report",
      },
      {
        label: "Pareto Report",
        to: { pathname: "/delays-pareto", search: "?assetId=13" },
        permission: "ui.navbar.caster.delays-pareto",
      },
      {
        label: "Mold Tracking",
        to: "/caster-mold",
        permission: "ui.navbar.caster.mold",
      },
    ],
  },
  {
    id: "lab",
    label: "Lab",
    permission: "ui.navbar.lab",
    items: [
      {
        label: "Data Entry",
        to: "/lab-data-entry",
        permission: "ui.navbar.lab.data-entry",
      },
      {
        label: "Chemistry Samples",
        to: "/lab-chemistry-samples",
        permission: "ui.navbar.lab.chemistry-samples",
      },
    ],
  },
  {
    id: "byi",
    label: "BYI",
    permission: "ui.navbar.byi",
    items: [
      {
        label: "Billet Yard Inventory",
        to: "/billets-yard-inventory",
        permission: "ui.navbar.byi.billets-yard-history", // TODO: change to billets-yard-inventory
      },
      {
        label: "Billets Yard History",
        to: "/billets-yard-history",
        permission: "ui.navbar.byi.billets-yard-history",
      },
      // TO BE DETERMINED: BYI Statistics, already implemented but unused
      // the following comments just hides this option from the UI (but reachable through the URL/path)
      // simply uncomment if it should be re-added
      // {
      //   label: "Billets Yard Statistics",
      //   to: "/billets-yard-statistics",
      //   permission: "ui.navbar.byi.billets-yard-history",
      // },
      {
        label: "Billets Yard Status",
        to: "/billets-yard-status",
        permission: "ui.navbar.byi.billets-yard-history",
      },
    ],
  },
  {
    id: "scrap",
    label: "SY",
    permission: "ui.navbar.scrap",
    items: [
      {
        label: "Charges Management",
        to: "/scrap-charges",
        permission: "ui.navbar.scrap",
      },
      {
        label: "Recipes",
        to: "/scrap-recipes",
        permission: "ui.navbar.scrap",
      },
      {
        label: "Scrap Layering Report",
        to: "/scrap-layering-report",
        permission: "ui.navbar.scrap",
      },
      {
        label: "Scrap Mix Analysis",
        to: "/scrap-mix-analysis",
        permission: "ui.navbar.scrap.scrap-mix-analysis",
      },
    ],
  },
];

const CustomNavbar = () => {
  const hasPermissionTo = useHasPermission();
  const [anchorElements, setAnchorElements] = useState<{
    [key: string]: HTMLElement | null;
  }>({});

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLButtonElement>,
    menuId: string,
  ) => {
    setAnchorElements((prevAnchors) => ({
      ...prevAnchors,
      [menuId]: event.currentTarget,
    }));
  };

  const handleMenuClose = (menuId: string) => {
    setAnchorElements((prevAnchors) => ({
      ...prevAnchors,
      [menuId]: null,
    }));
  };

  return (
    <>
      <Button
        component={Link}
        to="/meltshop-dashboard"
        sx={{
          marginRight: 2,
          color: "white",
          display: "flex",
          alignItems: "center",
        }}
      >
        Dashboard
      </Button>

      {menuConfigData.map((menu) => {
        if (menu.permission && !hasPermissionTo(menu.permission)) {
          return null;
        }

        const currentAnchorEl = anchorElements[menu.id] || null;
        const isMenuOpen = Boolean(currentAnchorEl);

        return (
          <div key={menu.id}>
            <Button
              aria-controls={`${menu.id}-menu`}
              aria-haspopup="true"
              data-testid={`nav-${menu.id}`}
              onClick={(event) => handleMenuOpen(event, menu.id)}
              sx={{
                marginRight: 2,
                color: "white",
                display: "flex",
                alignItems: "center",
              }}
            >
              {menu.label}
              {isMenuOpen ? (
                <ExpandLess sx={{ marginLeft: 0.5 }} />
              ) : (
                <ExpandMore sx={{ marginLeft: 0.5 }} />
              )}
            </Button>
            <Menu
              id={`${menu.id}-menu`}
              anchorEl={currentAnchorEl}
              keepMounted
              open={isMenuOpen}
              onClose={() => handleMenuClose(menu.id)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              {menu.items
                .filter(
                  (item) =>
                    !item.permission || hasPermissionTo(item.permission),
                )
                .map((item, index) => (
                  <MenuItem
                    key={`${menu.id}-item-${index}`}
                    component={Link}
                    to={item.to}
                    onClick={() => handleMenuClose(menu.id)}
                    sx={{
                      textDecoration: "none",
                      color: "inherit",
                      display: "block",
                      width: "100%",
                    }}
                  >
                    <Typography>{item.label}</Typography>
                  </MenuItem>
                ))}
            </Menu>
          </div>
        );
      })}
    </>
  );
};

export { CustomNavbar };
